import { createNamespacedHelpers } from "vuex";

const { mapGetters: userGetters } = createNamespacedHelpers("user");
const { mapGetters: brandingGetters } = createNamespacedHelpers("branding");

export default {
	data() {
		return {};
	},

	computed: {
		...userGetters([
			"activeProperty",
			"activeOutlet"
		]),
		...brandingGetters([
			"logoHome"
		]),
	},
};
